// extracted by mini-css-extract-plugin
export default {"block-header":"styles_block-header__Kn2vp","actions-container":"styles_actions-container__z1Thi","switch-container":"styles_switch-container__GLYY-"};